import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from "react";
import { useStore } from "zustand";
import { createPortalStore, } from "./createPortalStore";
const PortalContext = createContext(null);
export function PortalProvider({ defaultCountryCode, otpChannels, children, }) {
    const storeRef = useRef(null);
    if (!storeRef.current) {
        storeRef.current = createPortalStore({ defaultCountryCode, otpChannels });
    }
    return (_jsx(PortalContext.Provider, { value: storeRef.current, children: children }));
}
export function usePortalStore(selector) {
    const store = useContext(PortalContext);
    if (!store) {
        throw new Error("usePortalStore must be used inside <PortalProvider>");
    }
    return useStore(store, selector);
}
